window.SavvyCalculadora = (function () {
  var BASE = '/apps/discounts/calculators/';

  var GENERIC = 'Hubo un problema al guardar tus datos. Inténtalo de nuevo.';

  var RETRYABLE = [
    'shopify_throttled',
    'shopify_unavailable',
    'shopify_unreachable',
    'shop_payment_required',
    'shop_locked'
  ];

  /**
   * POST a calculator submission.
   *
   * @param {string} calculator slug — "protein" or "electrolytes"
   * @param {object} payload    the form answers; no shopId, see above
   * @returns {Promise<object>} the endpoint's JSON body on success. Rejects with an Error
   *                            carrying .code / .status / .errors for anything else.
   */
  function submit(calculator, payload) {
    return fetch(BASE + calculator, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (response) {
      // A proxy/App error can answer HTML (a 401 from the signature check, a Laravel error
      // page), so a failed parse must not become an unhandled SyntaxError.
      return response.text().then(function (raw) {
        var body = {};
        try {
          body = JSON.parse(raw);
        } catch (e) {
          body = { message: raw };
        }

        if (response.ok) {
          return body;
        }

        var error = new Error(body.message || 'Request failed with status ' + response.status);
        error.status = response.status;
        error.code = body.code || null;
        error.operation = body.operation || null;
        error.errors = body.errors || null;

        throw error;
      });
    });
  }

  /**
   * Turns whatever submit() rejected with into something worth showing a shopper. Never leaks
   * Shopify's own wording — the endpoint's `message` is developer-facing.
   *
   * @returns {{title: string, text: string}}
   */
  function errorMessage(error) {
    var code = error && error.code;

    // Kept from the old .NET-era handling: a phone number already on another customer is the one
    // rejection a shopper can actually fix themselves. An email collision no longer reaches here
    // — the app looks the customer up by email and updates them instead of creating a duplicate.
    if (code === 'shopify_user_errors' && hasAlreadyTaken(error.errors)) {
      return {
        title: 'Datos ya registrados',
        text: 'El correo electrónico o el teléfono ya están registrados para otro usuario. Verifica tus datos.'
      };
    }

    if (code === 'shopify_user_errors' || code === 'invalid_submission') {
      return {
        title: 'Datos no válidos',
        text: 'Alguno de los datos ingresados no es válido. Por favor revisa la información e inténtalo de nuevo.'
      };
    }

    if (RETRYABLE.indexOf(code) !== -1) {
      return {
        title: 'Inténtalo de nuevo',
        text: 'Estamos teniendo problemas para guardar tus datos en este momento. Vuelve a intentarlo en unos minutos.'
      };
    }

    // No code at all means fetch() itself rejected — offline, DNS, the request never left.
    if (!code) {
      return {
        title: 'Sin conexión',
        text: 'No pudimos conectarnos. Revisa tu conexión a internet e inténtalo de nuevo.'
      };
    }

    return { title: 'Error', text: GENERIC };
  }

  /**
   * Shopify's userErrors arrive as [{field, message}]; the shape is also flattened to
   * {field: [messages]} by Laravel's validator, so both are walked.
   */
  function hasAlreadyTaken(errors) {
    if (!errors) {
      return false;
    }

    return JSON.stringify(errors).indexOf('has already been taken') !== -1;
  }

  return { submit: submit, errorMessage: errorMessage };
})();
